/**
 * The shell's regions, empty: the skeleton web/index.html draws before the
 * bundle runs, drawn again while the app waits for /me so the first paint and
 * the wait are one picture. The classes are styled in index.html, inline,
 * where the first paint needs them.
 */

import type { ReactNode } from 'react';

export function BootSkeleton({ children }: { children?: ReactNode }) {
  return (
    <div className="boot" aria-hidden="true">
      <div className="boot-nav" />
      <div className="boot-main">
        <div className="boot-menu" />
        {children}
        <div className="boot-box" />
      </div>
    </div>
  );
}
